import propTypes from "prop-types";
import "../styles/Layout/AppLayout.style.css";
import Sidebar from "../Bars/SideBar/Sidebar.component";
import Topbar from "../Bars/TopBar/Topbar.component";
import { Outlet } from "react-router-dom";
import ActivityLoader from "../components/Universal/Loaders/ActivityLoader.component";
const AppLayout = () => {
  return (
    <div className="appLayout">
      <Sidebar />
      <div className="mainSec">
        <Topbar />
        <div className="appBody">
          <div className="bodyContent">
            <ActivityLoader />

            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;

AppLayout.propTypes = {
  children: propTypes.element,
};
